import React from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { ParagraphSM, TitleSM } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface GuildTicketsCalloutSectionProps {
  isScrollingLayout?: boolean
}

export const GuildTicketsCalloutSection: React.FC<GuildTicketsCalloutSectionProps> = ({
  isScrollingLayout = false,
}) => {
  const { t } = useTranslate('guild')
  const showPink = true
  //TODO cleaning up for now, added a task to make this an actual component in Contentful once SKETCH theatrical run is complete
  //https://linear.app/angel-studios/issue/WEB-4175/add-tickets-callout-section-as-new-item-in-contentful

  return (
    <section
      className={classNames(
        'relative w-full pb-16 lg:pb-20',
        isScrollingLayout
          ? '-mt-[12vh] se:-mt-20 md:-mt-40 lg:-mt-38 z-50'
          : '-mt-[11vh] se:-mt-50 md:-mt-40 lg:-mt-36',
      )}
    >
      {/*Mobile*/}
      <div className="relative sm:hidden">
        <div
          className="mx-6 mb-1 max-w-[1283px] rounded-2xl bg-transparent p-[1px] 3xl:mx-auto"
          style={
            showPink
              ? undefined
              : {
                  backgroundImage:
                    'linear-gradient(166.78deg, #EDD7C6 1.42%, #D6A177 14.6%, #FEDEC6 39.98%, #D48D59 60.48%, #A66141 85.7%, #612B12 94.6%)',
                }
          }
        >
          <div className="relative">
            <div
              className={classNames('flex rounded-2xl text-white', showPink ? 'bg-sketch-pink' : 'bg-core-gray-900')}
            >
              <div className="mx-8 -mt-16 mb-1 rounded-2xl p-[1px]">
                <div className="relative flex flex-col items-center justify-center">
                  <Image
                    className="w-[160px]"
                    width={269}
                    height={325}
                    alt="Guild Tickets & Eyeder"
                    src={'/c_fill,w_269/v1753824813/angel-studios/guild/tickets/guild-tickets-graphic_4x.webp'}
                  />
                  <div className="flex py-2 text-center text-white">
                    <div className="w-full max-w-[662px] sm:w-3/5">
                      <TitleSM
                        weight="bold"
                        className="md:photon-title-md lg:photon-heading-sm xl:photon-heading-md mb-3"
                      >
                        <Translate t={t} i18nKey="premiumMembersTwoTicketsToSketch">
                          Premium Members get two free tickets to SKETCH!
                        </Translate>
                      </TitleSM>
                      <ParagraphSM
                        color={showPink ? 'white' : 'core-gray-400'}
                        weight="medium"
                        className="lg:photon-paragraph-lg max-w-[662px]"
                      >
                        <Translate t={t} i18nKey="simpleFlexibleBooking">
                          Simple & flexible booking. Up to a $30 value per movie & this benefit easily covers your
                          premium membership. You&apos;ll want to see this on the big screen. Bring your kids.
                        </Translate>
                      </ParagraphSM>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*Desktop*/}
      <div className="hidden bg-transparent sm:block">
        <div
          className={classNames('mx-12 mb-1 rounded-2xl bg-transparent p-[1px] 3xl:mx-auto 3xl:max-w-[2000px]')}
          style={
            showPink
              ? undefined
              : {
                  backgroundImage:
                    'linear-gradient(166.78deg, #EDD7C6 1.42%, #D6A177 14.6%, #FEDEC6 39.98%, #D48D59 60.48%, #A66141 85.7%, #612B12 94.6%)',
                }
          }
        >
          <div className="relative">
            <div
              className={classNames(
                'flex rounded-2xl p-8 text-white',
                showPink ? 'bg-sketch-pink' : 'bg-core-gray-900',
              )}
            >
              <div className="w-full sm:w-3/5">
                <TitleSM
                  weight="bold"
                  className="md:photon-title-md lg:photon-heading-sm xl:photon-heading-md mb-3 max-w-[662px]"
                >
                  <Translate t={t} i18nKey="premiumMembersTwoTicketsToSketch">
                    Premium Members get two free tickets to SKETCH!
                  </Translate>
                </TitleSM>
                <ParagraphSM
                  color={showPink ? 'white' : 'core-gray-400'}
                  weight="medium"
                  className="lg:photon-paragraph-lg max-w-[662px]"
                >
                  <Translate t={t} i18nKey="simpleFlexibleBooking">
                    Simple & flexible booking. Up to a $30 value per movie & this benefit easily covers your premium
                    membership. You&apos;ll want to see this on the big screen. Bring your kids.
                  </Translate>
                </ParagraphSM>
              </div>
              <div className="relative ml-auto hidden w-1/3 sm:block">
                <Image
                  className="absolute right-0 w-[435px] sm:-top-1/4 sm:block md:-top-1/2 lg:-top-3/4 lg:right-10 xl:-top-full 2xl:right-16 3xl:right-20"
                  width={269}
                  height={325}
                  alt="Guild Tickets & Eyeder"
                  src={'/c_fill,w_435/v1753824813/angel-studios/guild/tickets/guild-tickets-graphic_4x.webp'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
